import React from 'react';
import { Platform, View, type ViewProps } from 'react-native';

/** Frosted-glass blur on web; native shows the translucent surface alone. */
const GLASS_BLUR = Platform.OS === 'web' ? { backdropFilter: 'blur(14px)' } : null;

export interface CardProps extends ViewProps {
  className?: string;
  /** Elevated cards (sheets, modals, highlighted blocks). */
  elevated?: boolean;
}

export function Card({ className, elevated = false, style, ...rest }: CardProps) {
  return (
    <View
      className={`rounded-card border border-glass-border ${
        elevated ? 'bg-glass-2' : 'bg-glass'
      }${className ? ` ${className}` : ''}`}
      style={[GLASS_BLUR, style]}
      {...rest}
    />
  );
}
